import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  ResAgentDelete,
  ResBusinessSourceDelete,
  ResCorporateDelete,
  ResGuaranteeCodeDelete,
  ResMarketSegmentDelete,
} from "../../../Services/Service";

const createReservationDeleteThunk = (type, service) => createAsyncThunk(
  type,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await service(payload);
      return { payload, response };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message || "Unable to delete record" },
      );
    }
  },
);

export const deleteReservationAgent = createReservationDeleteThunk(
  "reservationDelete/deleteAgent", ResAgentDelete,
);
export const deleteReservationCorporate = createReservationDeleteThunk(
  "reservationDelete/deleteCorporate", ResCorporateDelete,
);
export const deleteReservationMarketSegment = createReservationDeleteThunk(
  "reservationDelete/deleteMarketSegment", ResMarketSegmentDelete,
);
export const deleteReservationBusinessSource = createReservationDeleteThunk(
  "reservationDelete/deleteBusinessSource", ResBusinessSourceDelete,
);
export const deleteReservationGuaranteeCode = createReservationDeleteThunk(
  "reservationDelete/deleteGuaranteeCode", ResGuaranteeCodeDelete,
);

const deleteThunks = [
  deleteReservationAgent,
  deleteReservationCorporate,
  deleteReservationMarketSegment,
  deleteReservationBusinessSource,
  deleteReservationGuaranteeCode,
];

const reservationDeleteSlice = createSlice({
  name: "reservationDelete",
  initialState: { deleting: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isAnyOf(...deleteThunks.map((thunk) => thunk.pending)), (state) => {
        state.deleting = true;
        state.error = null;
      })
      .addMatcher(isAnyOf(...deleteThunks.map((thunk) => thunk.fulfilled)), (state) => {
        state.deleting = false;
      })
      .addMatcher(isAnyOf(...deleteThunks.map((thunk) => thunk.rejected)), (state, action) => {
        state.deleting = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default reservationDeleteSlice.reducer;
